module.exports = (date) => Math.floor(date.getTime() / 1000)
